import { AccessGrant, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { generateMockLocation } from 'mocks/graphqlMocks/location';

export function mockedAssignToAccessGrantsData(
  assignToAccessGrants: AccessGrant[]
): Pick<Mutation, 'assignToAccessGrants'> {
  return {
    assignToAccessGrants
  };
}

export const mockedAssignToAccessGrantsDataForMutation = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantId0',
    doors: [],
    locations: [generateMockLocation({ id: 'mockedLocationId' })]
  })
]);

export const mockedAssignToAccessGrantsDataForMutation1 = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantId0',
    doors: [generateMockDoor({ id: 'mockedDoorId0' })]
  })
]);

export const mockedAssignToAccessGrantsDataForMutation2 = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantId0',
    doors: [generateMockDoor({ id: 'mockedDoorId0' })]
  }),
  generateMockAccessGrant({
    id: 'mockedAccessGrantId1',
    doors: [generateMockDoor({ id: 'mockedDoorId0' })]
  }),
  generateMockAccessGrant({
    id: 'mockedAccessGrantId2',
    doors: [generateMockDoor({ id: 'mockedDoorId0' })]
  })
]);

export const mockedAssignToAccessGrantsDataForMutationDoor0 = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantId1',
    doors: [generateMockDoor({ id: 'mockedDoorId0' })]
  })
]);

export const mockedAssignToAccessGrantsDataForMutationTestGroup1 = (accessGrantId: string) =>
  mockedAssignToAccessGrantsData([
    generateMockAccessGrant({
      id: accessGrantId,
      locations: [generateMockLocation({ id: 'TestGroup1', name: 'Test group 1' })]
    })
  ]);

export const mockedAssignToAccessGrantsDataForCoContractorsTestGroup1 = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantIdCo-contractors',
    locations: [generateMockLocation({ id: 'TestGroup1', name: 'Test group 1' })]
  })
]);

export const mockedAssignToAccessGrantsDataForCoContractorsTestGroup2 = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantIdCo-contractors',
    locations: [generateMockLocation({ id: 'TestGroup2', name: 'Test group 2' })]
  })
]);

export const mockedAssignToAccessGrantsDataForCoContractorsDoor1 = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantIdCo-contractors',
    doors: [generateMockDoor({ id: 'mockedDoorId1' })]
  })
]);

export const mockedAssignToAccessGrantsDataForCoContractorsDoor2 = mockedAssignToAccessGrantsData([
  generateMockAccessGrant({
    id: 'mockedAccessGrantIdCo-contractors',
    doors: [generateMockDoor({ id: 'mockedDoorId2' })]
  })
]);
